import { useEffect } from 'react';
import { KWELLO_ICON, KwelloSvgIcon } from '../../components/icon/KwelloSvgIcon';

import Footer from '../auth/Footer';
import Header from '../auth/Header';

import styles from './CompliancePage.module.scss';

function CompliancePage({
  title,
  downloadLink,
  children,
}: {
  title: string;
  downloadLink: string;
  children: any;
}) {
  useEffect(() => {
    document.title = title;
  }, [title]);

  const downloadPdf = () => {
    const link = document.createElement('a');
    link.href = downloadLink;
    link.setAttribute('download', '');
    link.click();
  };

  return (
    <>
      <Header />
      <div className={styles.container}>
        <div className={`${styles['title-container']} base-loud-desktop-blue-700`}>
          <div>{title}</div>
          <span onClick={downloadPdf} className={styles.download}>
            Export PDF
            <KwelloSvgIcon icon={KWELLO_ICON.PDF_ICON} />
          </span>
        </div>
        <div className={`${styles.content} soft-desktop-gray-700`}>{children}</div>
      </div>
      <Footer fixed />
    </>
  );
}

export default CompliancePage;
